import { safeSetItem } from "@/lib/storage/safe-local";
import { useEffect, useState } from "react";

const KEY = "cb16.recentlyViewed";
const MAX = 8;

function read(): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((v) => typeof v === "string") : [];
  } catch {
    return [];
  }
}

function write(slugs: string[]) {
  if (typeof window === "undefined") return;
  try {
    safeSetItem(KEY, JSON.stringify(slugs.slice(0, MAX)));
    window.dispatchEvent(new CustomEvent("cb16:recently-viewed"));
  } catch {
    /* quota / private mode */
  }
}

export function pushRecentlyViewed(slug: string) {
  const current = read().filter((s) => s !== slug);
  write([slug, ...current]);
}

export function useRecentlyViewed(excludeSlug?: string): string[] {
  const [slugs, setSlugs] = useState<string[]>([]);
  useEffect(() => {
    const sync = () => setSlugs(read().filter((s) => s !== excludeSlug));
    sync();
    window.addEventListener("cb16:recently-viewed", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("cb16:recently-viewed", sync);
      window.removeEventListener("storage", sync);
    };
  }, [excludeSlug]);
  return slugs;
}
